import angular from 'angular';

class HtmlPostComponentController {
  constructor(uiAlertService, PostService, $translate) {
    this.uiAlertService = uiAlertService;
    this.postService = PostService;
    this.$translate = $translate;
  }

  $onInit() {
    // this.isEditing = false;
    this.isEditing = !this.post; // If no post is given, we want to create (edit) a new post.
  }

  $onChanges(changes) {
    if (changes.isEditing) {
      this.isEditing = changes.isEditing.currentValue;
    }
  }

  onSave(post) {
    this.post = post;
    this.toggleEditPost();
  }

  toggleEditPost() {
    this.isEditing = !this.isEditing;
  }

  deletePost(event) {
    this.uiAlertService.showConfirm(this.$translate.instant('POST.DELETE.POST'), this.$translate.instant('POST.DELETE.ARE_YOU_SURE'))
      .then(() => this.postService.deletePost(this.post.postId))
      .then(() => this.onDelete());
  }
}

angular.module('ll').component('htmlPost', {
  template: require('./html-post.component.html'),
  controller: HtmlPostComponentController,
  controllerAs: 'vm',
  bindings: {
    post: '<',
    isEditing: '<',
    isExpanded: '<',
    onDelete: '&'
  }
});
